/* eslint-disable max-len */
var cdnSrc = function cdnSrc(src) {
  return "https://cdn.ov.app/media/gift-guide-23/".concat(src);
};

var categories = {
  idEMS: 'Q29tcG9uZW50Tm9kZToxMTY1',
  // EMS Local (3 Categories)
  image: {
    alt: 'Background of green mountainside.',
    height: 656,
    width: 2840,
    src: cdnSrc('Category.jpg')
  },
  imageMobile: {
    alt: 'Background of green mountainside.',
    height: 520,
    width: 750,
    src: cdnSrc('Category-Mobile.jpg')
  }
};
var help = [{
  id: '1',
  copy: 'Add a gift box and free gift note at checkout.',
  image: {
    alt: 'A Christmas ornament with blue gift boxes and Outdoor Voices tote bags in it.',
    src: cdnSrc('Help-Ornament-1.jpg'),
    height: 1040,
    width: 812
  },
  imageMobile: {
    alt: 'A Christmas ornament with blue gift boxes and Outdoor Voices tote bags in it.',
    src: cdnSrc('Help-Ornament1-Mobile.jpg'),
    height: 1042,
    width: 814
  },
  title: 'Let us do the wrapping.',
  url: '/pages/gifting-services'
}, {
  id: '2',
  copy: 'For answers on fit, ship times, returns, and more, head to our F.A.Q page.',
  image: {
    alt: 'A Christmas ornament with an Outdoor Voices store front in it.',
    src: cdnSrc('Help-Ornament-2.jpg'),
    height: 1200,
    width: 812
  },
  imageMobile: {
    alt: 'A Christmas ornament with an Outdoor Voices store front in it.',
    src: cdnSrc('Help-Ornament2-Mobile.jpg'),
    height: 940,
    width: 768
  },
  title: 'Questions for us?',
  url: '/pages/help-center'
}, {
  id: '3',
  copy: "Buy online and pickup in-shop, or visit us in-store to see whatever you\u2019ve been eyeing IRL.",
  image: {
    alt: 'A Christmas ornament with the words Outdoor Voices on it.',
    src: cdnSrc('Help-Ornament-3.jpg'),
    height: 1364,
    width: 812
  },
  imageMobile: {
    alt: 'A Christmas ornament with the words Outdoor Voices on it.',
    src: cdnSrc('Help-Ornament3-Mobile.jpg'),
    height: 940,
    width: 768
  },
  title: 'Get it faster.',
  url: '/pages/visit-us'
}];
var hero = {
  image: {
    alt: 'A group of people sitting in chairs on the mountainside.',
    height: 1366,
    width: 2840,
    src: cdnSrc('Hero-Desktop.jpg')
  },
  imageMobile: {
    alt: '!A group of people sitting in chairs on the mountainside.',
    height: 500,
    width: 750,
    src: cdnSrc('Hero-Mobile.jpg')
  },
  title: 'Gifting Things.',
  copy: 'OV Gift Guide – ',
  copyItalic: 'So much cheer so little time.',
  url: '/collections/bestsellers'
};
var giftsForHer = {
  copy: "Gifts for her \u2014 thank us later.",
  cta: 'Shop — Women',
  image: {
    alt: 'A woman wearing a hooded jacket in front of a mountain.',
    src: cdnSrc('Her.jpg'),
    height: 600,
    width: 730
  },
  imageMobile: {
    alt: 'A smiling woman wearing the PrimoFleece 1/4 Zip Hoodie in Frosty Fairweather.',
    src: cdnSrc('Her-Mobile.jpg'),
    height: 422,
    width: 612
  },
  title: 'Get her this.',
  url: '/collections/gifts-for-her'
};
var giftsForHim = {
  copy: "Gifts for him \u2014 you're welcome.",
  cta: 'Shop — Men',
  image: {
    alt: 'A man holding a cup with mountains in the background.',
    src: cdnSrc('Him.jpg'),
    height: 600,
    width: 730
  },
  imageMobile: {
    alt: 'A man holding a cup with mountains in the background.',
    src: cdnSrc('Him-Mobile.jpg'),
    height: 422,
    width: 612
  },
  title: 'Get him this.',
  url: '/collections/gifts-for-him'
};
var giftCards = {
  title: 'A gift for all. Ta-da.',
  cta: 'Shop &mdash; Gift Cards',
  imageBackground: cdnSrc('Gift-Card-BG.jpg'),
  imageCard: {
    alt: 'Outdoor Voices Gift Card',
    height: 426,
    width: 646,
    src: cdnSrc('Gift-Card.png')
  },
  imageCase: {
    height: 426,
    width: 646,
    alt: 'Outdoor Voices Gift Card Envelope',
    src: cdnSrc('Envelope.png')
  },
  url: '/products/digital-gift-certificate'
};
var props = {
  categories: categories,
  help: help,
  hero: hero,
  giftsForHer: giftsForHer,
  giftsForHim: giftsForHim,
  giftCards: giftCards
};
export default props;